import { isDateControl, JsonFormsRendererRegistryEntry, rankWith, uiTypeIs } from '@jsonforms/core';
import controlRenderer from './DateControlRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(2, uiTypeIs('CustomDateControl')),
};
